import { Button as ButtonPrimitive, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const Button = React.forwardRef(({ className, children, ...props }, ref) => {
    var _a;
    return (React.createElement(ButtonPrimitive, { className: cn("in-button", `in-button--${(_a = props["variant"]) !== null && _a !== void 0 ? _a : props["data-variant"]}`, className), ref: ref, ...props }, children));
});
Button.displayName = "Button";
export { Button };
//# sourceMappingURL=button.js.map